import React from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

const BlogList = ({ title, subtitle, logo, concept, cover, trail }) => (
    <header>
        <div className="background" style={{ backgroundImage: `url(${cover})` }}>
            {/* <img src={cover} className="cover-image" /> */}
            {/* <svg viewBox="-2990 -73 1920 720.043">
                <path className="backgroundColor" d="M0,0H1920V474L0,720.043Z" transform="translate(-2990 -73)" />
            </svg> */}
        </div>
        <div className="content">
            <div className="info">
                <Link to={'/'}>
                    <img src={logo} className={logo} alt="" />
                </Link>
                <h1>{title}</h1>
                <p>{subtitle}</p>
            </div>
            {/* {concept && <img src={concept} alt={'Smartparking Concept'} className={'concept bounceInRight'} />} */}
        </div>
        <img className="trail" src={trail} />
    </header>
);
export default BlogList;



// WEBPACK FOOTER //
// ./src/components/ui/Header/Header.js